import React from 'react'
import HomePod from '../Homepod/HomePod'
import MacBookPro from '../MacBookPro/MacBookPro'
function MacAndHome() {
  return (
    <>
        <section className=" row ">
<MacBookPro/>
<HomePod/>
</section>
    
    </>
  )
}

export default MacAndHome